<ng-container *ngIf="user; else unknownUserTmpl">
  <y42-avatar
    *ngIf="isUserProfileSetupComplete"
    [name]="user.full_name"
    [src]="user.profile_pic"
    [size]="size"
    matTooltipPosition="above"
    [matTooltip]="user.full_name"
    [borderColor]="borderColor"
  >
  </y42-avatar>
  <y42-icon
    *ngIf="!isUserProfileSetupComplete"
    class="justify-center"
    icon="user"
    [iconStyle]="{ fontSize: size + 'px', width: size + 'px' }"
  ></y42-icon>
</ng-container>

<ng-template #unknownUserTmpl>
  <div
    *ngIf="!user"
    [matTooltip]="state.isSystemUser ? 'y42-bot' : 'Inactive User' + (userIdentity ? ' (' + userIdentity + ')' : '')"
    [style.width.px]="size"
    [style.height.px]="size"
    class="deleted-user"
    matTooltipPosition="above"
  >
    <y42-icon [icon]="state.isSystemUser ? y42ShortLogoIcon : 'user-slash'"></y42-icon>
  </div>
</ng-template>
